"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _Typography = _interopRequireDefault(require("../../../Typography"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _SpotIllustration = _interopRequireDefault(require("../../SpotIllustration"));
var Styled = _interopRequireWildcard(require("./ErrorSection.styles"));
var _messages = _interopRequireDefault(require("./messages"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ErrorSection = function ErrorSection(_ref) {
  var onButtonClick = _ref.onButtonClick,
    light = _ref.light;
  var intl = (0, _reactIntl.useIntl)();
  var isMobile = (0, _useMediaQuery["default"])('(max-width:640px)');
  return /*#__PURE__*/_react["default"].createElement(Styled.ErrorSectionWrapper, null, /*#__PURE__*/_react["default"].createElement(_SpotIllustration["default"], {
    name: "status-error",
    size: "small"
  }), /*#__PURE__*/_react["default"].createElement(Styled.ErrorSectionContentWrapper, null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    level: "title",
    kind: light ? 'interaction' : 'inverse'
  }, intl.formatMessage(_messages["default"].title)), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    level: "body",
    kind: light ? 'interaction' : 'inverseLighter'
  }, intl.formatMessage(_messages["default"].subtitle))), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onButtonClick,
    variant: light ? 'default' : 'defaultInverse',
    fullWidth: isMobile
  }, intl.formatMessage(_messages["default"].buttonLabel)));
};
ErrorSection.propTypes = process.env.NODE_ENV !== "production" ? {
  onButtonClick: _propTypes["default"].func,
  light: _propTypes["default"].bool
} : {};
var _default = exports["default"] = ErrorSection;